<template>
  <div class="course-information-box panel panel-dark btn-group-vertical">
    <h3 class="panel-heading">
      {{ course.title }}
      <span v-if="!course.active">noch in Planung</span>
    </h3>

    <div class="panel-body">
      <div v-html="textToMarkdown(course.textDescriptionList)"></div>

      <template v-if="!course.recording">
        <template v-if="cycles">
          <template v-if="cycles.length">
            <br />
            <ul class="list-group">
              <li class="list-group-item list-group-item-info">Termine:</li>
              <li
                class="list-group-item"
                v-for="cycle in cycles"
                :key="'cycle-' + cycle._id"
              >
                {{ createCycleDateRange(cycle) }}
                <div
                  v-if="cycle.note"
                  class="list-group-item list-group-item-warning"
                >
                  <i class="fa fa-info-circle fa-lg text-info"></i>
                  <strong>{{ cycle.note }}</strong>
                </div>
              </li>
            </ul>
          </template>

          <template v-else>
            <br />
            <div class="alert alert-info">
              aktuell werden keine Termine angeboten
            </div>
          </template>
        </template>
        <div v-else class="big-loader fa fa-spinner fa-pulse"></div>
      </template>
    </div>

    <template v-if="course.active && course.page">
      <a :href="`/${course.page.url}`" class="btn btn-lg btn-warning btn-block"
        >zur Kursbuchung</a
      >
    </template>
  </div>
</template>

<script>
import {
  cycleDateRange,
  cycleDay,
  cycleStartTime,
  isPublicVisible,
} from '../../_shared/hooks/useCycleHelper';
import { textToMarkdown } from '../../_shared/hooks/useTextHelper';

export default {
  name: 'CourseInformationBox',
  props: ['course'],
  computed: {
    cycles() {
      if (!this.course.cycles) {
        return;
      }

      return this.course.cycles.filter((cycle) =>
        isPublicVisible(cycle, this.course)
      );
    },
  },
  methods: {
    textToMarkdown,
    createCycleDateRange(cycle) {
      return `${cycleDateRange(cycle)} (${cycleDay(cycle)}) um ${cycleStartTime(
        cycle
      )} Uhr`;
    },
  },
};
</script>

<style lang="scss" scoped>
.panel-body ul {
  text-align: left;
}

.list-group {
  margin-left: 0;

  .list-group-item-warning {
    margin-top: 8px;
  }
}
</style>
